import {
  ODataHeader,
  ODataString,
  ODataDate,
  ODataDecimal,
} from "pbas-vue-components";

import { translate2 } from "../trans2";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

const PlanTermsDetailsHeaders = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "globals.firstname",
    type: new ODataString("FirstName"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.lastname",
    type: new ODataString("LastName"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.certificate",
    type: new ODataString("Certificate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.plantermsdetails.ehc",
    type: new ODataDecimal("EHC", {
      getString: (item, type) => {
        console.log("get string ehc")
        const value = item.EHC;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
      getHtml: (item, type) => {
        console.log("get html ehc")
        const val = type.getString(item, type);
        console.log(val, typeof val)
        if (val !== "0.00") {
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px;color:red'>" +
            val +
            "</div>"
          );
        }
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
          val +
          "</div>"
        );
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.dental",
    type: new ODataDecimal("Dental", {
      getString: (item, type) => {
        const value = item.Dental;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
      getHtml: (item, type) => {
        const val = type.getString(item, type);
        console.log(val, typeof val)
        if (val !== "0.00") {
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px;color:red'>" +
            val +
            "</div>"
          );
        }
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
          val +
          "</div>"
        );
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.plantermsdetails.life",
    type: new ODataDecimal("Life", {
      getString: (item, type) => {
        const value = item.Life;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
      getHtml: (item, type) => {
        const val = type.getString(item, type);
        if (val !== "0.00") {
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px;color:red'>" +
            val +
            "</div>"
          );
        }
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
          val +
          "</div>"
        );
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.plantermsdetails.ltd",
    type: new ODataDecimal("LTD", {
      getString: (item, type) => {
        const value = item.LTD;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
      getHtml: (item, type) => {
        const val = type.getString(item, type);
        if (val !== "0.00") {
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px;color:red'>" +
            val +
            "</div>"
          );
        }
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
          val +
          "</div>"
        );
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.plantermsdetails.adnd",
    type: new ODataDecimal("ADnD", {
      getString: (item, type) => {
        const value = item.ADnD;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
      getHtml: (item, type) => {
        const val = type.getString(item, type);
        if (val !== "0.00") {
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px;color:red'>" +
            val +
            "</div>"
          );
        }
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
          val +
          "</div>"
        );
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.adjustments.total",
    type: new ODataDecimal("Total", {
      getString: (item, type) => {
        const value = item.Total;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
      getHtml: (item, type) => {
        const val = type.getString(item, type);
        if (val !== "0.00") {
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px;color:red'>" +
            val +
            "</div>"
          );
        }
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
          val +
          "</div>"
        );
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];
export default PlanTermsDetailsHeaders;
